import authPartner from '../../fields/other/authPartner';

export const MUTATION_UPDATE_AUTH_PARTNER = /* GraphQL */ `
	mutation($id: String!, $input: AuthPartnerUpdate!) {
		updateAuthPartner(id: $id, input: $input) {
			${authPartner}
		}
	}
`;
